export const userRoles = Object.freeze({
  ADMIN: "admin",
  DEBUG: "debug",
  CUSTOMER: "customer",
})

export const tableViews = Object.freeze({
  BASIC: "basic",
  EXTENDED: "extended",
})

export const bodyParts = Object.freeze({
  SPINE: "Spine",
  BRAIN: "Brain",
  KNEE: "Knee",
  SHOULDER: "Shoulder",
})

export const logsSource = Object.freeze({
  RAMSOFT: "RAMSOFT",
  OUTSIDE_V3: "OUTSIDE V3",
})

export const dbDateTimeFormat = "yyyy-MM-dd HH:mm:ss.SSS"

export const dbDateFormat = "yyyy-MM-dd"
